// apps/admin/src/web/runtime-config.ts
//
// Where environment configuration comes from at run time (ADR-0178 D2).
// Same contract as apps/backoffice/src/runtime-config.ts; admin serves the
// generated /config.js from its own Hono server rather than an nginx hook,
// because it runs `node dist/server/index.js` and has no nginx to hook.
//
// The import.meta.env fallback is for LOCAL DEV and unit tests only.
//
// Only `env.ts` should call this. Everything else reads `env`.

declare global {
  var __HEYROOT_CONFIG__: Record<string, string> | undefined;
}

export function readRuntimeConfig(): Record<string, string | undefined> {
  const buildTime =
    typeof import.meta !== 'undefined'
      ? ((import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {})
      : {};

  // Empty values are dropped rather than overriding a real build-time one.
  const present = Object.entries(globalThis.__HEYROOT_CONFIG__ ?? {}).filter(
    ([, value]) => typeof value === 'string' && value !== '',
  );

  return { ...buildTime, ...Object.fromEntries(present) };
}
